import PropTypes from 'prop-types'
import { isGroupAdmin } from '@/features/dashboard/power/group/groupDisplay'
import useAuth from '@/hooks/useAuth'
import PermissionRequired from '@/pages/403'

/**
 * Blocks a route unless the API reports the user as a group admin (their me
 * payload lists at least one administered org group). Fail-closed: a missing or
 * empty `administeredGroups` blocks the route. Mirrors the `requiresGroupAdmin`
 * nav gate in `nav-access.js` so the dashboard link and the route agree.
 */
const GroupAdminGuard = ({ children }) => {
    const { user } = useAuth()

    if (!isGroupAdmin(user)) {
        return <PermissionRequired />
    }

    return <>{children}</>
}

GroupAdminGuard.propTypes = {
    children: PropTypes.node
}

export default GroupAdminGuard
